// extracted by mini-css-extract-plugin
module.exports = {"container":"HowDoYouPayUsTab_container__1i3rS"};